jQuery(document).ready(function(jQuery){

  jQuery('.Gallery_Section .Gallery_Slider').slick({
    slidesToShow: 3,
    slidesToScroll: 1,
    centerMode: false,
    infinite: true,
    variableWidth: false,
    adaptiveHeight: true,
    responsive: [
      {
        breakpoint: 768,
        settings: {
          slidesToShow: 2
        }
      },
      {
        breakpoint: 479,
        settings: {
          slidesToShow: 1
        }
      }
    ]
  });

  jQuery('.Workbench_Achive_Section .Workbench_Achive_Blocks.Desktop_Slider').slick({
    slidesToShow: 4,
    slidesToScroll: 1,
    centerMode: false,
    infinite: true,
    variableWidth: false,
    arrows: true,
    prevArrow:"<button type='button' aria-label='Previous' class='slick-prev pull-left'><svg aria-hidden='true' focusable='false' role='presentation' class='icon icon-chevron-left' viewBox='0 0 284.49 498.98'><path d='M249.49 0a35 35 0 0 1 24.75 59.75L84.49 249.49l189.75 189.74a35.002 35.002 0 1 1-49.5 49.5L10.25 274.24a35 35 0 0 1 0-49.5L224.74 10.25A34.89 34.89 0 0 1 249.49 0z'></path></svg></button>",
    nextArrow:"<button type='button' aria-label='Next' class='slick-next pull-right'><svg aria-hidden='true' focusable='false' role='presentation' class='icon icon-chevron-right' viewBox='0 0 284.49 498.98'><path d='M35 498.98a35 35 0 0 1-24.75-59.75l189.74-189.74L10.25 59.75a35.002 35.002 0 0 1 49.5-49.5l214.49 214.49a35 35 0 0 1 0 49.5L59.75 488.73A34.89 34.89 0 0 1 35 498.98z'></path></svg></button>"
  });

  jQuery('.Workbench_Achive_Section .Workbench_Achive_Blocks.Mobile_Slider').slick({
    slidesToShow: 2,
    slidesToScroll: 1,
    rows: 2,
    centerMode: false,
    infinite: true,
    variableWidth: false,
    arrows: true,
    prevArrow:"<button type='button' aria-label='Previous' class='slick-prev pull-left'><svg aria-hidden='true' focusable='false' role='presentation' class='icon icon-chevron-left' viewBox='0 0 284.49 498.98'><path d='M249.49 0a35 35 0 0 1 24.75 59.75L84.49 249.49l189.75 189.74a35.002 35.002 0 1 1-49.5 49.5L10.25 274.24a35 35 0 0 1 0-49.5L224.74 10.25A34.89 34.89 0 0 1 249.49 0z'></path></svg></button>",
    nextArrow:"<button type='button' aria-label='Next' class='slick-next pull-right'><svg aria-hidden='true' focusable='false' role='presentation' class='icon icon-chevron-right' viewBox='0 0 284.49 498.98'><path d='M35 498.98a35 35 0 0 1-24.75-59.75l189.74-189.74L10.25 59.75a35.002 35.002 0 0 1 49.5-49.5l214.49 214.49a35 35 0 0 1 0 49.5L59.75 488.73A34.89 34.89 0 0 1 35 498.98z'></path></svg></button>"
  });

  jQuery('.Custom_Testimonial_Slider').slick({
    slidesToShow: 1,
    slidesToScroll: 1,
    infinite: true,
    arrows: true,
    dots: false,
    prevArrow:"<button type='button' aria-label='Previous' class='slick-prev pull-left'><svg aria-hidden='true' focusable='false' role='presentation' class='icon icon-chevron-left' viewBox='0 0 284.49 498.98'><path d='M249.49 0a35 35 0 0 1 24.75 59.75L84.49 249.49l189.75 189.74a35.002 35.002 0 1 1-49.5 49.5L10.25 274.24a35 35 0 0 1 0-49.5L224.74 10.25A34.89 34.89 0 0 1 249.49 0z'></path></svg></button>",
    nextArrow:"<button type='button' aria-label='Next' class='slick-next pull-right'><svg aria-hidden='true' focusable='false' role='presentation' class='icon icon-chevron-right' viewBox='0 0 284.49 498.98'><path d='M35 498.98a35 35 0 0 1-24.75-59.75l189.74-189.74L10.25 59.75a35.002 35.002 0 0 1 49.5-49.5l214.49 214.49a35 35 0 0 1 0 49.5L59.75 488.73A34.89 34.89 0 0 1 35 498.98z'></path></svg></button>"
  });


  $('.You_May_Also_Like_Section .product-recommendations .grid').slick({
    slidesToShow: 4,
    slidesToScroll: 1,
    centerMode: false,
    infinite: false,
    arrows: false,
    variableWidth: false,
    prevArrow:"<button type='button' aria-label='Previous' class='slick-prev pull-left'><svg focusable='false' width='17' height='14' class='icon icon--nav-arrow-left  icon--direction-aware ' viewBox='0 0 17 14'><path d='M17 7H2M8 1L2 7l6 6' stroke='currentColor' stroke-width='2' fill='none'></path></svg></button>",
    nextArrow:"<button type='button' aria-label='Next' class='slick-next pull-right'><svg focusable='false' width='17' height='14' class='icon icon--nav-arrow-right  icon--direction-aware ' viewBox='0 0 17 14'><path d='M0 7h15M9 1l6 6-6 6' stroke='currentColor' stroke-width='2' fill='none'></path></svg></button>",
    responsive: [
      {
        breakpoint: 1200,
        settings: {
          slidesToShow: 3
        }
      },
      {
        breakpoint: 768,
        settings: {
          slidesToShow: 2,
          autoplay: true,
          autoplaySpeed: 4000
        }
      },
      {
        breakpoint: 479,
        settings: {
          slidesToShow: 1
        }
      }
    ]
  });

  // Media slider
  jQuery('.js-media-slider--slider').slick({
    slidesToShow: 2,
    arrows: true,
    infinite: true,
    prevArrow:"<button type='button' aria-label='Previous' class='slick-prev pull-left'><svg aria-hidden='true' focusable='false' role='presentation' class='icon icon-chevron-left' viewBox='0 0 284.49 498.98'><path d='M249.49 0a35 35 0 0 1 24.75 59.75L84.49 249.49l189.75 189.74a35.002 35.002 0 1 1-49.5 49.5L10.25 274.24a35 35 0 0 1 0-49.5L224.74 10.25A34.89 34.89 0 0 1 249.49 0z'></path></svg></button>",
    nextArrow:"<button type='button' aria-label='Next' class='slick-next pull-right'><svg aria-hidden='true' focusable='false' role='presentation' class='icon icon-chevron-right' viewBox='0 0 284.49 498.98'><path d='M35 498.98a35 35 0 0 1-24.75-59.75l189.74-189.74L10.25 59.75a35.002 35.002 0 0 1 49.5-49.5l214.49 214.49a35 35 0 0 1 0 49.5L59.75 488.73A34.89 34.89 0 0 1 35 498.98z'></path></svg></button>",
    responsive: [
      {
        breakpoint: 768,
        settings: {
          slidesToShow: 1,
          dots: true
        }
      }
    ]
  });

  // Education sliders
  jQuery('.js-videos__slider').each(function() {
    $(this).slick({
      slidesToShow: 3,
      infinite: false,
      appendArrows: $(this).siblings('.videos__header').children('.videos__controls'),
      prevArrow:"<button type='button' aria-label='Previous' class='slick-prev pull-left'><svg aria-hidden='true' focusable='false' role='presentation' class='icon icon-chevron-left' viewBox='0 0 284.49 498.98'><path d='M249.49 0a35 35 0 0 1 24.75 59.75L84.49 249.49l189.75 189.74a35.002 35.002 0 1 1-49.5 49.5L10.25 274.24a35 35 0 0 1 0-49.5L224.74 10.25A34.89 34.89 0 0 1 249.49 0z'></path></svg></button>",
      nextArrow:"<button type='button' aria-label='Next' class='slick-next pull-right'><svg aria-hidden='true' focusable='false' role='presentation' class='icon icon-chevron-right' viewBox='0 0 284.49 498.98'><path d='M35 498.98a35 35 0 0 1-24.75-59.75l189.74-189.74L10.25 59.75a35.002 35.002 0 0 1 49.5-49.5l214.49 214.49a35 35 0 0 1 0 49.5L59.75 488.73A34.89 34.89 0 0 1 35 498.98z'></path></svg></button>",
      responsive: [
        {
          breakpoint: 900,
          settings: {
            slidesToShow: 2
          }
        },
        {
          breakpoint: 600,
          settings: {
            slidesToShow: 1,
            dots: true,
            arrows: false
          }
        }
      ]
    });
  });

});


jQuery(document).ready(function(jQuery){
  var $ = jQuery;
	
  // Product tabs
  $('.product__tabs-item').click(function() {
    var type = $(this).data('type');
    
    $('.product__tabs-item').removeClass('active');
    $(this).addClass('active');
    
    $('.product__content-item').removeClass('active');
    $(`.product__content-item[data-type="${type}"]`).addClass('active');
  });
  
  // store locator scroll
  $("#fitter-events-scroll").click(function() {
    $('html, body').animate({
      scrollTop: $("#fitter-events").offset().top
    }, 1000);
  });
  
  $("#contact-scroll").click(function() {
    $('html, body').animate({
      scrollTop: $("#contact").offset().top
    }, 1000);
  });
  
  
  // ==========================================================================
  //	Multi-level accordion nav
  // ==========================================================================
  $('.acnav__label').click(function () {
      var label = $(this);
      var parent = label.parent('.has-children');
      var list = label.siblings('.acnav__list');

      if ( parent.hasClass('is-open') ) {
          list.slideUp('fast');
          parent.removeClass('is-open');
      }
      else {
          list.slideDown('fast');
          parent.addClass('is-open');
      }
  });
  
  
  $( ".select-state" ).change(function() {
    let no_space = this.value.replace(/\s/g , "-").toLowerCase();
    if (no_space == '') {
      $('html, body').animate({
        'scrollTop' : 0
      },2000);
    } else {
      $('html, body').animate({
        'scrollTop' : $(`#${no_space}`).position().top - 60
      },2000);
    }
  });
  
  $( ".filter-button" ).click(function() {
    var types = [];
    $.each($("input[name='fitter']:checked"), function(){
      types.push($(this).val());
    });
    if (types.length == 0 ) {
      $('.contact-grid-item').each(function(item) {
        $(this).show();
      })
    } else {
      $('.contact-grid-item').each(function(item) {
        let item_data = $(this).data('types').split(",");
        let result = types.every(i => item_data.includes(i));
        if (result) {
          $(this).show();
        } else {
          $(this).hide();
        }
      })
    }
  });

});

jQuery(".Find_Putter_Game_Section .Bottom_Section .Putters_Game_Blocks .Putters_Game_Block .rte").each(function () {
  function e() {
      jQuery(".Find_Putter_Game_Section .Bottom_Section .Putters_Game_Blocks .Putters_Game_Block .rte").css("height", "auto");
      var e = -1;
      jQuery(".Find_Putter_Game_Section .Bottom_Section .Putters_Game_Blocks .Putters_Game_Block .rte").each(function () {
          var t = jQuery(this).outerHeight();
          e = t > e ? t : e
      }), jQuery(".Find_Putter_Game_Section .Bottom_Section .Putters_Game_Blocks .Putters_Game_Block .rte").css("height", e)
  }
  jQuery(this), jQuery(window).on("load resize orientationchange", e)
});

jQuery(document).ready(function(jQuery){

  jQuery('a[href^="#"], .Scroll_Section a').on('click',function (e) {
    //e.preventDefault();
    var target = this.hash;
    var $target = jQuery(target);
    jQuery('html, body').stop().animate({
      'scrollTop': $target.offset().top - 50
    }, 1200, 'swing', function () {
      //window.location.hash = target;
    });
  });

  $('.Putters_Game_Block .rte').matchHeight();

  jQuery(".media-slider--icon").each(function(button) {
    jQuery(this).on('click',function (e) {
      e.preventDefault();
      var iframe = $(this).parents('.media-slider--image').find('iframe').attr('data-src');
      $(this).parents('.media-slider--image').find('iframe').attr('src',iframe)
    });
  });

  jQuery(".videos__icon-container").each(function(button) {
    jQuery(this).on('click',function (e) {
      e.preventDefault();
      var iframe = $(this).parents('.videos__slide-image').find('iframe').attr('data-src');
      $(this).parents('.videos__slide-image').find('iframe').attr('src',iframe)
    });
  });

  var iframeProduct = jQuery('.product__video-video').find('iframe').attr('data-src');
  jQuery('.product__video-video').find('iframe').attr('src',iframeProduct)
  
});

$(window).on('resize orientationchange', function(){
  $('.Putters_Game_Block .rte').matchHeight();
});

$(".Hover_Effect span").hover(function() {
  var index = $(this).data('index');
  $('.feature-row__text .feature-row__wrap').each(function(i){
    if(index == i){
      $(this).addClass('active');
    }
  });
}, function() {
  $('.feature-row__wrap').removeClass('active');
});


